import { SET_SNAG_PROJECTS } from '../actions/types';

const initialState = {
    projects: [],
    isLoaded: false,
};

export default function snagDetailsReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_SNAG_PROJECTS:
            return {
                ...state,
                projects: payload || [],
                isLoaded: true,
            };
        default:
            return state;
    }
}
